// Vanity aliases that people type from a video carry no campaign of their own.
// When the visitor's URL has no utm_* parameter at all, the redirect appends
// this query so the visit is attributed. Any existing utm_* parameter wins and
// the query passes through unchanged. The React route, the CloudFront route
// guard and the S3 redirect document all apply the same rule.
// Kept dependency free so the app shell can import it without pulling in the
// public page content that siteRoutes.js carries.
const PUBLIC_ROUTE_REDIRECT_DEFAULT_QUERIES = Object.freeze({
  '/youtube': 'utm_source=youtube&utm_medium=video&utm_campaign=youtube_vanity',
  '/ytmembership': 'utm_source=youtube&utm_medium=video&utm_campaign=ytmembership',
  '/yt-membership': 'utm_source=youtube&utm_medium=video&utm_campaign=ytmembership',
});

function withRedirectDefaultQuery(search = '', defaultQuery = '') {
  const current = search === '?' ? '' : String(search || '');
  if (!defaultQuery || /(?:^|[?&])utm_/.test(current)) return current;
  return current ? `${current}&${defaultQuery}` : `?${defaultQuery}`;
}

module.exports = { PUBLIC_ROUTE_REDIRECT_DEFAULT_QUERIES, withRedirectDefaultQuery };
